import Swiper from "swiper";
import GLightbox from "glightbox";

window.roomSwipers = [];

export const SwiperRooms = () => {

	const sliders = document.querySelectorAll(".swiper-rooms");
	let i = 0;

	sliders.forEach((slider) => {

		const swiper = new Swiper(slider, {
			loop: true,
			centeredSlides: true,
			centeredSlidesBounds: false,
			slidesPerView: 1,
			speed: 700,
			observer: true,
			observeParents: true,
			spaceBetween: 0,
			loopAdditionalSlides: 1,
			spaceBetween: 24,
			breakpoints: {
				1024: {
					spaceBetween: 0,
				},
			}
		});

		swiper.slideNext();

		const prevBtn = document.getElementById("swiper-rooms-prev-" + slider.dataset.id);
		const nextBtn = document.getElementById("swiper-rooms-next-" + slider.dataset.id);

		// Add disabled ao btn quando preciso
		const updateNavButtons = () => {
			if (swiper.isBeginning) {
				prevBtn.disabled = true;
			} else {
				prevBtn.disabled = false;
			}

			if (swiper.isEnd) {
				nextBtn.disabled = true;
			} else {
				nextBtn.disabled = false;
			}
		};

		prevBtn.addEventListener("click", () => {
			swiper.slidePrev();
			updateNavButtons();
		});

		nextBtn.addEventListener("click", () => {
			swiper.slideNext();
			updateNavButtons();
		});

		updateNavButtons();

		i++;
	});

	GLightbox({ selector: ".glightbox" });
};